//** Paths */
import { PATH_ONLINE_SUB, PATH_ONLINE_NAVIGATION } from "../../routes/paths";
//* Schemas
import { schemaPaymentDetails } from "../../schema/paymentPaymentDetailsSchema.js";
import { schemaPolicyOutcome } from "../../schema/policyOutcomeSchema.js";

//** Page order */
import { pageOrder } from "./pageOrder";

//** What 'stage' of the application is a particular page associated with. */
const stages = {
  PREQUAL: "PreQualification",
  UNDERWRITING: "UnderWriting",
  NEWBUSINESS: "NewBusiness",
  PAYMENT: "Payment",
};

import { sharedPages } from "./sharedPages";
import { Application } from "../const/enums";
import { pageName } from "../../config/pageInfo/pageNames.js";

// import {
//   schemaQuoteSummary,
//   schemaTwoPersonQuoteSummary,
// } from "../../schema/preQualValidationSchema";

//----------------------------------------------------------------

//** The page(s) information - Controls the render and the flow */
export const onlinePages = () => {
  let pageDetails = sharedPages(Application.ONLINE, "personOne");

  return [
    {
      index: pageOrder.ACCEPT,
      title: "Accept and Proceed",
      identifier: pageName.ACCEPT,
      stage: stages.PREQUAL,
      routePath: PATH_ONLINE_SUB.accept,
      nextRoutePath: PATH_ONLINE_NAVIGATION.personal,
      previousRoutePath: PATH_ONLINE_NAVIGATION.accept,
      fieldNames: null,
      showProgressBar: false,
      activeStep: null,
      schema: null,
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
    },
    {
      index: pageOrder.PP_ONLINE_PAYMENT,
      title: "Payment Details",
      identifier: pageName.PP_ONLINE_PAYMENT,
      stage: stages.PAYMENT,
      routePath: PATH_ONLINE_SUB.ppOnlinePayment,
      nextRoutePath: PATH_ONLINE_NAVIGATION.ppConfirmation,
      previousRoutePath: PATH_ONLINE_NAVIGATION.ppContact,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 4,
      schema: schemaPaymentDetails(),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
    },
    {
      index: pageOrder.PP_ONLINE_POLICY_OUTCOME,
      title: "Policy Outcome",
      identifier: pageName.PP_ONLINE_POLICY_OUTCOME,
      stage: stages.NEWBUSINESS,
      routePath: PATH_ONLINE_SUB.ppOnlinePolicyOutcome,
      nextRoutePath: null,
      previousRoutePath: PATH_ONLINE_NAVIGATION.ppConfirmation,
      fieldNames: null,
      showProgressBar: true,
      activeStep: 4,
      schema: schemaPolicyOutcome("personOne", Application.ONLINE),
      dualSchema: null,
      valid: false, // Set to true when the next page is clicked
    },
    ...pageDetails,
  ];
};
